import { JSX, useEffect, useState } from "react";
import { Logo } from "../../common/svg/Logo";
import { Button } from "../../common/components/Button";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../common/enums/RouteEnum";

export const ThankYouPageContainer = (): JSX.Element => {
    const navigate = useNavigate();
    const [secondsLeft, setSecondsLeft] = useState(10);

    useEffect(() => {
        if (secondsLeft <= 0) {
            navigate(RouteEnum.CHOICE_SELECTION);
        }

        const timer = setTimeout(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [secondsLeft, navigate]);

    return (
        <div className={"p-thank-you"}>
            <div className={"p-thank-you__logo"}>
                <Logo />
            </div>
            <div className={"p-thank-you__content"}>
                <h1 className={"p-thank-you__content__title"}>
                    Thank you for voting!
                </h1>
                <p className={"p-thank-you__content__subtitle"}>
                    Your choice will help shape the future of SPRSO. Stay tuned
                    for the winner!
                </p>
                <Button
                    type={"button"}
                    variant={"secondary"}
                    onClick={() => navigate(RouteEnum.CHOICE_SELECTION)}
                >
                    Back to start
                </Button>
                <p className={"p-thank-you__content__redirect-text"}>
                    You will be automatically redirected in{" "}
                    <span>
                        {secondsLeft} second{secondsLeft !== 1 ? "s" : ""}
                    </span>
                </p>
            </div>
        </div>
    );
};
